import Text from 'components/Text'
import ImgStoryblok from 'components/ImgStoryblok'
import './discountBanner.scss'

const DiscountBanner = () => {
  return (
    <div className="register-discount-banner">
      <div className="register-discount-banner__content">
        <div>
          <Text p className="register-discount-banner__text">
            você ganhou um cupom de desconto
          </Text>
          <Text p size={11} className="register-discount-banner__text">
            Preencha abaixo e garanta{' '}
            <span className="register-discount-banner__highlight-text">
              5% a mais de desconto
            </span>{' '}
            na sua renegociação
          </Text>
        </div>
        <ImgStoryblok
          width={137}
          height={148}
          src="https://a.storyblok.com/f/119473/x/bea2984d41/discount-coupon.svg"
          pictureProps={{ className: 'register-discount-banner__figure' }}
          className="register-discount-banner__image"
          alt="Cupom de desconto"
        />
      </div>
    </div>
  )
}

export default DiscountBanner
